<template>
  <div class="sb-radio-buttons">
    <template v-for="(option, index) in selectionOptions">
      <component
        v-if="useCustomComponent"
        :is="customComponent"
        :key="option.id + index"
        :option="option"
        :selected="isSelected(option)"
        @select="handleSelect"
        :loading="loading"
      ></component>
      <label :class="radioControlClass(option)" v-else :key="option.id + index">
        <div class="control__indicator"></div>
        <input
          type="radio"
          :value="option.value"
          @input="$emit('input', option.value)"
          :checked="option.value === value"
        >
        <div class="text-wrapper">
          <span class="label">{{ option.displayValue }}</span>
          <p v-if="option.subTextDisplayValue" class="label-subtext">{{ option.subTextDisplayValue }}</p>
        </div>
      </label>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SbRadioButtons',
  props: {
    value: {
      required: false
    },
    customComponent: {
      type: Object
    },
    selectionOptions: {
      type: Array,
      required: true,
      default: () => ([])
    },
    selectedOption: {
      default: null,
      required: false
    },
    loading: {
      default: false,
      required: false
    }
  },
  computed: {
    useCustomComponent () {
      return this.customComponent !== undefined
    },
    selected: {
      get () {
        return this.selectedOption
      },
      set (option) {
        this.selhandleSelectect(option)
      }
    }
  },
  methods: {
    radioControlClass (option) {
      const classes = ['control--radio']
      if (option.value === this.value) classes.push('checked')
      return classes
    },
    handleSelect (option) {
      this.$emit('select', option)
    },
    isSelected (option) {
      return !!this.selectedOption && this.selectedOption.value === option.value
    }
  }
}
</script>

<style lang="scss" scoped>
.checked .control__indicator {
  transition: all 250ms;
  background-color: white;
  border-color: #2470af;
  box-shadow: inset 0 0 0 0.25em #2470af;
}
.control--radio:hover {
  .control__indicator {
    background-color: #e4e8ee;
    transition: all 250ms;
  }
}
.control--radio {
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  font-size: 16px;
}
input {
  display: none;
}
.control__indicator {
  height: 1em;
  border-radius: 50%;
  width: 1em;
  box-shadow: inset 0 0 0 1px #cbced2;
}
.text-wrapper {
  display: flex;
  flex-direction: column;
  color: #343e4f;
  margin-left: 0.5em;
  .label {
    font-weight: 600;
    line-height: 1em;
  }
  .label-subtext {
    font-size: 0.8em;
    line-height: 1.5em;
    color: #9ea1a7;
  }
}
</style>